import * as React from 'react'
import { adminRoleName } from '../../Users/UpdateUser/constants'
import { getAdminCardStyles } from './styling'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

export const AdminSalesTeamPosition = () => {
  const styles = getAdminCardStyles(useTheme())
  return (
    <Box sx={styles.topSection}>
      <Box sx={styles.label}>{adminRoleName}</Box>
    </Box>
  )
}
